var map = {
	"./bund/favicons/android-chrome-192x192.png": 66565,
	"./bund/favicons/android-chrome-512x512.png": 28213,
	"./bund/favicons/apple-touch-icon.png": 97418,
	"./bund/favicons/favicon-16x16.png": 79653,
	"./bund/favicons/favicon-32x32.png": 4821,
	"./bund/favicons/favicon.ico": 36502,
	"./bund/icons/information.svg": 19882,
	"./bund/icons/muted.svg": 14661,
	"./bund/icons/share.svg": 14025,
	"./bund/icons/unmuted.svg": 63878,
	"./bund/logoDarkVariantDesktop.svg": 25697,
	"./bund/logoDarkVariantMobile.svg": 9333,
	"./bund/logoDesktop.svg": 88752,
	"./bund/logoMobile.svg": 64878,
	"./bund/unmute.mp3": 90011,
	"./catatec/favicons/android-chrome-192x192.png": 4701,
	"./catatec/favicons/android-chrome-512x512.png": 69389,
	"./catatec/favicons/apple-touch-icon.png": 12978,
	"./catatec/favicons/favicon-16x16.png": 46637,
	"./catatec/favicons/favicon-32x32.png": 94525,
	"./catatec/favicons/favicon.ico": 80654,
	"./catatec/icons/information.svg": 37362,
	"./catatec/icons/muted.svg": 52749,
	"./catatec/icons/share.svg": 54033,
	"./catatec/icons/unmuted.svg": 92894,
	"./catatec/logoDesktop.svg": 84536,
	"./catatec/logoMobile.svg": 55782,
	"./catatec/unmute.mp3": 62483,
	"./default/favicons/android-chrome-192x192.png": 11105,
	"./default/favicons/android-chrome-512x512.png": 95889,
	"./default/favicons/apple-touch-icon.png": 70406,
	"./default/favicons/favicon-16x16.png": 42489,
	"./default/favicons/favicon-32x32.png": 72025,
	"./default/favicons/favicon.ico": 26026,
	"./default/icons/information.svg": 77526,
	"./default/icons/muted.svg": 74561,
	"./default/icons/share.svg": 66069,
	"./default/icons/unmuted.svg": 3426,
	"./default/logoDarkVariantDesktop.svg": 75413,
	"./default/logoDarkVariantMobile.svg": 89585,
	"./default/logoDesktop.svg": 76028,
	"./default/logoMobile.svg": 21970,
	"./default/unmute.mp3": 94055,
	"./yak/favicons/android-chrome-192x192.png": 72687,
	"./yak/favicons/android-chrome-512x512.png": 75303,
	"./yak/favicons/apple-touch-icon.png": 81448,
	"./yak/favicons/favicon-16x16.png": 81863,
	"./yak/favicons/favicon-32x32.png": 48095,
	"./yak/favicons/favicon.ico": 76672,
	"./yak/icons/information.svg": 18264,
	"./yak/icons/muted.svg": 76531,
	"./yak/icons/share.svg": 5687,
	"./yak/icons/unmuted.svg": 41088,
	"./yak/logoDesktop.svg": 11306,
	"./yak/logoMobile.svg": 20216,
	"./yak/unmute.mp3": 44445
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60951;